module.exports = __webpack_public_path__ + "img/pro-icon.7c51a346.svg";